import { useState } from "react";
import { Check, Loader2, Tag } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { createCheckout } from "@/lib/api";

export const ReferralInput = ({ suffix = "hero", dark = false }) => {
  const [open, setOpen] = useState(!!localStorage.getItem("miria_referral"));
  const [code, setCode] = useState(localStorage.getItem("miria_referral") || "");
  const [result, setResult] = useState(null);
  const [checking, setChecking] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const busy = checking || redirecting;

  const verify = async () => {
    const trimmed = code.trim();
    if (!trimmed || busy) return;
    setChecking(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/referral/validate`, {
        params: { code: trimmed },
      });
      setResult(data);
      if (data.valid) {
        localStorage.setItem("miria_referral", trimmed.toUpperCase());
        setChecking(false);
        setRedirecting(true);
        try {
          const { checkout_url } = await createCheckout();
          window.location.href = checkout_url;
          return;
        } catch (err) {
          toast.error("Codice applicato. Il checkout non si è aperto: usa il pulsante Inizia ora.");
          setRedirecting(false);
        }
      } else {
        localStorage.removeItem("miria_referral");
      }
    } catch (err) {
      setResult({ valid: false });
    }
    setChecking(false);
  };

  if (!open) {
    return (
      <button
        data-testid={`referral-open-btn-${suffix}`}
        onClick={() => setOpen(true)}
        className={`mx-auto mt-4 flex items-center gap-2 py-2 text-sm font-semibold underline underline-offset-4 transition-colors ${
          dark
            ? "text-purple-100 decoration-purple-300 hover:text-white"
            : "text-purple-600 decoration-purple-300 hover:text-purple-800"
        }`}
      >
        <Tag className="h-4 w-4" /> Hai un codice amico?
      </button>
    );
  }

  return (
    <div data-testid={`referral-box-${suffix}`} className="mx-auto mt-3 max-w-sm">
      <div className="flex items-center gap-2">
        <input
          data-testid={`referral-code-input-${suffix}`}
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          onKeyDown={(e) => e.key === "Enter" && verify()}
          placeholder="CODICE AMICO"
          disabled={busy}
          className="w-full rounded-full border border-purple-200 bg-white px-4 py-2 text-base font-semibold uppercase tracking-wider text-slate-800 outline-none transition-colors placeholder:text-slate-300 focus:border-purple-500 disabled:opacity-70"
        />
        <button
          data-testid={`referral-verify-btn-${suffix}`}
          onClick={verify}
          disabled={busy}
          className="shrink-0 rounded-full bg-purple-600 px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-purple-700 disabled:opacity-60"
        >
          {redirecting ? (
            "Apro il checkout..."
          ) : checking ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            "Verifica"
          )}
        </button>
      </div>
      {result?.valid && (
        <p
          data-testid={`referral-valid-msg-${suffix}`}
          className={`mt-2 flex items-center justify-center gap-1.5 text-xs font-semibold ${
            dark ? "text-green-300" : "text-green-600"
          }`}
        >
          <Check className="h-4 w-4" /> Codice amico di {result.name} applicato
        </p>
      )}
      {result && !result.valid && (
        <p
          data-testid={`referral-invalid-msg-${suffix}`}
          className={`mt-2 text-center text-xs font-semibold ${dark ? "text-red-300" : "text-red-500"}`}
        >
          {result.app_unreachable
            ? "Servizio referral momentaneo non raggiungibile, riprova tra poco."
            : "Codice non valido. Controlla e riprova."}
        </p>
      )}
    </div>
  );
};
